module.exports = __webpack_public_path__ + "img/testimonials_spotlight.0195f089.png";